import Enum from "../../../../../../enums/Enum";

const ConditionActiveEnum = new Enum({
    INACTIVE: {name: "Inactive"},
    ACTIVE: {name: "Active"}
});

export default ConditionActiveEnum;
